import { MyPortfolioTable } from '@widgets/MyPortfolioTable';
import React from 'react';
import './MyPortfolioPage.scss';
// update accpunt id
export const MyPortfolioPage: React.FC = () => {
    return (
        <div className='margin-20-top-div'>
            <div
                className='flex-only'
                style={{ height: '10vh', padding: '2vh 0px' }}
            >
                <div className='bold-text-dashboard'>Dashboard /</div>
                <div className='grey-text-dashboard'> My Portfolio</div>
            </div>
            <div className='my-portfolio-table'>
                <MyPortfolioTable accountId={0} />
            </div>
        </div>
    );
};
